import { api } from "./api";

// Same rule as backend/wording_rule.py (patterns served by /api/public/wording-rule); JS needs Unicode word classes.
const W = "[\\p{L}\\p{N}_]";
const B = `(?:(?<=${W})(?!${W})|(?<!${W})(?=${W}))`;
const conv = (p) => p.replaceAll("[\\w'-]", "[\\p{L}\\p{N}_'-]").replaceAll("\\w", W).replaceAll("\\b", B);
let rule = null;
let loading = null;

export function loadWordingRule() {
  if (!loading) {
    loading = api.get("/public/wording-rule").then(({ data }) => {
      rule = { claims: new RegExp(data.claims.map(conv).join("|"), "giu"), equiv: new RegExp(data.equivalence.map(conv).join("|"), "giu"), neg: new RegExp(conv(data.negation), "iu"), clause: new RegExp(conv(data.clause), "iu") };
    }).catch(() => { loading = null; });
  }
  return loading;
}

function hits(rx, text) {
  rx.lastIndex = 0;
  for (const m of text.matchAll(rx)) {
    const before = text.slice(Math.max(0, m.index - 60), m.index).split(rule.clause).pop();
    if (!rule.neg.test(`${before} `)) return m[0];
  }
  return null;
}

export function forbidden(text, alternatives = false) {
  if (!rule || typeof text !== "string" || !text) return null;
  return hits(rule.claims, text) || (alternatives ? hits(rule.equiv, text) : null);
}
